import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { WkCreateDialogService } from '../../services/wk-create-dialog.service';
import {
  OpenCreateTemplateDialogAction,
  OPEN_CREATE_TEMPLATE_DIALOG,
} from '../actions/app.custom-actions';

@Injectable()
export class CreateDialogsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly createDialogService: WkCreateDialogService
  ) {}

  openCreateTemplateDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<OpenCreateTemplateDialogAction>(OPEN_CREATE_TEMPLATE_DIALOG),
        map(() => this.createDialogService.openCreateDialogTemplate())
      ),
    { dispatch: false }
  );
}
